// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2270":"1a575bd3","5362":"eb5e7ae4","5581":"9a6b3316","6056":"0bfb293a","6139":"960491bc"}[chunkId] + ".css";
};